import React from 'react'

const Checked = props => (
  <svg width={22.03} height={22.03} {...props}>
    <image
      data-name="Rechthoek 678 kopi\xEBren 4"
      width={22.03}
      height={22.03}
      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAQ0lEQVQ4jWNkYGD4z0BFwERNw0CABYnNSKFZ/9ENZOjZ20OW90ucS+COobqXRw0cNXDUwOFhIHIBS5Xia5CX2AwMDACGhQkn3Qg5ygAAAABJRU5ErkJggg=="
    />
  </svg>
)

export default Checked



// WEBPACK FOOTER //
// ./src/components/shared/checked.js